import { styled } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import type { AccordionSummaryOwnProps } from '@mui/material';
import MuiAccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';

const AccordionSummary = styled((props: AccordionSummaryOwnProps) => (
	<MuiAccordionSummary expandIcon={<ExpandMoreIcon />} {...props} />
))(({ theme }) => ({
	backgroundColor: theme.palette.surface.tertiary,
	flexDirection: 'row',
	[`&.${accordionSummaryClasses.root}`]: {
		justifyContent: 'left',
		minHeight: 30,
		height: 30,
		padding: theme.spacing(0, 0, 0, 0),
	},
	[`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
		transform: 'rotate(180deg)',
	},
	[`& .${accordionSummaryClasses.content}`]: {
		padding: theme.spacing(0, 1, 0, 0),
		width: 'fit-content',
		flexGrow: 0,
	},
}));

export default AccordionSummary;
